import React, { Component } from 'react';

import Header from './header_footer/header/Header';

import './landing_page/landingPage.css';

const mainDiv = {
  marginTop: "10%",
  display: "inline-block"
};

const myDiv = {
  display: "flex",
  alignItems: "center",
  height: "40px"
}

const logo = {
  width: "40px"
}

const mainText = {
  marginBottom: "0px",
  fontSize: "20px",
  color: "black",
  fontWeight: "bold",
  paddingLeft: "12px"
}

const secondaryText = {
  fontSize: "16px",
  color: "black",
  marginTop: "16px"
}


export default class NotFound extends Component {
  render() {
    return (
      <div>
      <div className="hero-not-found" id="homeImage">
      <Header></Header>
      <div style={{textAlign: "center"}}>
        <div style={mainDiv} className="center-div">
          
          <div style={myDiv}>
            <img style={logo} src="/images/warning.png" alt="Logotipo freguesia"></img>
            <p style={mainText}>Ups, parece que se perdeu na nossa aldeia...</p>
          </div>
          <p style={secondaryText}>A página que tentou aceder não se encontra disponível. <br></br>Dê uns passos atrás e continue a explorar a aldeia do Sabugueiro.</p>
          
        </div>
      </div>
      </div>
      </div>
      
    )
  }
}
